module.exports = __webpack_public_path__ + "img/home-about-专属学习计划.e2f795df.png";